import React from 'react'
import { Link } from 'react-router-dom'

import { Helmet } from 'react-helmet'
import YouTube from 'react-youtube'

import Footer from '../components/footer'
import './home.css'

const Home = (props) => {
  return (
    <div className="home-container10">
      <Helmet>
        <title>R.A.C.E. Consulting</title>
        <meta
          name="description"
          content="Empowering high school students to confidently own their future through college admissions, scholarships &amp; career paths with less stress, stronger family ties."
        />
        <meta property="og:title" content="R.A.C.E. Consulting" />
        <meta
          property="og:description"
          content="Independent consultant helping teens go from high school to their future, making college admissions, scholarships &amp; career choices clear and stress-free."
        />
        <meta
          property="og:image"
          content="https://aheioqhobo.cloudimg.io/v7/_playground-bucket-v2.teleporthq.io_/4dd8a2a4-fe48-48cd-8cb1-f0a7df20a883/ea77a8a8-ecc2-4dba-b7bc-a9a53426c250?org_if_sml=1&amp;force_format=original"
        />
        <link
          rel="canonical"
          href="https://notus-pro-wndqzl.teleporthq.site/"
        />
      </Helmet>
      <div className="home-container11">
        <div className="home-thq-hero-elm">
          <img
            alt="image"
            src="https://raceconsulting24.com/homepagehero-1500h.jpg"
            loading="eager"
            fetchpriority="high"
            className="home-image10"
          />
          <div className="home-thq-bg-elm"></div>
          <div className="home-container12">
            <div className="home-container13">
              <h1 className="home-text10">
                R.A.C.E. Consulting partners with high school students to help
                them take ownership of their future - with less stress and
                stronger connections at home.
              </h1>
              <span className="home-text11">
                Through personalized 1-on-1 support, we build meaningful
                relationships with each student, equipping them with tailored
                academic guidance, career exploration tools, and resources to
                navigate high school with purpose and confidence.
              </span>
            </div>
            <img
              alt="image"
              src="https://raceconsulting24.com/gray-vector.svg"
              className="home-image11"
            />
            <img
              alt="image"
              src="https://raceconsulting24.com/white-vector.svg"
              className="home-thq-image-elm"
            />
          </div>
        </div>
        <header
          data-thq="thq-navbar"
          className="home-thq-navbar-interactive-elm"
        >
          <Link to="/" className="home-navlink10">
            <img
              alt="image"
              src="https://raceconsulting24.com/logo.png"
              className="home-image12"
            />
          </Link>
          <Link to="/" className="home-navlink11">
            <h1 className="home-text12">R.A.C.E. Consulting, LLC</h1>
          </Link>
          <div data-thq="thq-navbar-nav" className="home-thq-desktop-menu-elm">
            <nav className="home-thq-links-elm1">
              <Link to="/" className="home-navlink12">
                Home
              </Link>
              <Link to="/services" className="home-navlink13">
                Services
              </Link>
              <Link to="/about-us" className="home-navlink14">
                About Us
              </Link>
              <Link to="/contact-us" className="home-navlink15">
                Contact Us
              </Link>
            </nav>
            <div className="home-container14">
              <a
                href="https://www.facebook.com/share/1CHjJ68yyA/?mibextid=wwXIfr"
                target="_blank"
                rel="noreferrer noopener"
                className="home-link1"
              >
                <svg
                  viewBox="0 0 877.7142857142857 1024"
                  className="home-icon10"
                >
                  <path d="M713.143 73.143c90.857 0 164.571 73.714 164.571 164.571v548.571c0 90.857-73.714 164.571-164.571 164.571h-107.429v-340h113.714l17.143-132.571h-130.857v-84.571c0-38.286 10.286-64 65.714-64l69.714-0.571v-118.286c-12-1.714-53.714-5.143-101.714-5.143-101.143 0-170.857 61.714-170.857 174.857v97.714h-114.286v132.571h114.286v340h-304c-90.857 0-164.571-73.714-164.571-164.571v-548.571c0-90.857 73.714-164.571 164.571-164.571h548.571z"></path>
                </svg>
              </a>
              <a
                href="https://www.instagram.com/race.consulting?igsh=ZjU1bzB3OG01cnBv&amp;utm_source=qr"
                target="_blank"
                rel="noreferrer noopener"
                className="home-link2"
              >
                <svg
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  className="home-icon12"
                >
                  <g fill="none" stroke="currentColor" strokeWidth="1.5">
                    <path
                      d="M12 16a4 4 0 1 0 0-8a4 4 0 0 0 0 8"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    ></path>
                    <path d="M3 16V8a5 5 0 0 1 5-5h8a5 5 0 0 1 5 5v8a5 5 0 0 1-5 5H8a5 5 0 0 1-5-5Z"></path>
                    <path
                      d="m17.5 6.51l.01-.011"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    ></path>
                  </g>
                </svg>
              </a>
              <a
                href="https://www.linkedin.com/in/melissa-decker-7a6181303?utm_source=share&amp;utm_campaign=share_via&amp;utm_content=profile&amp;utm_medium=ios_app"
                target="_blank"
                rel="noreferrer noopener"
                className="home-link3"
              >
                <svg
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  className="home-icon17"
                >
                  <path
                    d="M1 2.838A1.84 1.84 0 0 1 2.838 1H21.16A1.837 1.837 0 0 1 23 2.838V21.16A1.84 1.84 0 0 1 21.161 23H2.838A1.84 1.84 0 0 1 1 21.161zm8.708 6.55h2.979v1.496c.43-.86 1.53-1.634 3.183-1.634c3.169 0 3.92 1.713 3.92 4.856v5.822h-3.207v-5.106c0-1.79-.43-2.8-1.522-2.8c-1.515 0-2.145 1.089-2.145 2.8v5.106H9.708zm-5.5 10.403h3.208V9.25H4.208zM7.875 5.812a2.063 2.063 0 1 1-4.125 0a2.063 2.063 0 0 1 4.125 0"
                    fill="currentColor"
                    clipRule="evenodd"
                    fillRule="evenodd"
                  ></path>
                </svg>
              </a>
              <a
                href="https://www.youtube.com/@MelissaDecker-n6k"
                target="_blank"
                rel="noreferrer noopener"
                className="home-link4"
              >
                <svg
                  height="32"
                  width="32"
                  viewBox="0 0 32 32"
                  className="home-icon20"
                >
                  <path
                    fill="currentColor"
                    d="M29.41 9.26a3.5 3.5 0 0 0-2.47-2.47C24.76 6.2 16 6.2 16 6.2s-8.76 0-10.94.59a3.5 3.5 0 0 0-2.47 2.47A36 36 0 0 0 2 16a36 36 0 0 0 .59 6.74a3.5 3.5 0 0 0 2.47 2.47c2.18.59 10.94.59 10.94.59s8.76 0 10.94-.59a3.5 3.5 0 0 0 2.47-2.47A36 36 0 0 0 30 16a36 36 0 0 0-.59-6.74M13.2 20.2v-8.4l7.27 4.2Z"
                  ></path>
                </svg>
              </a>
            </div>
          </div>
          <div data-thq="thq-burger-menu" className="home-thq-burger-menu-elm">
            <svg viewBox="0 0 1024 1024" className="home-icon19">
              <path d="M128 554.667h768c23.552 0 42.667-19.115 42.667-42.667s-19.115-42.667-42.667-42.667h-768c-23.552 0-42.667 19.115-42.667 42.667s19.115 42.667 42.667 42.667zM128 298.667h768c23.552 0 42.667-19.115 42.667-42.667s-19.115-42.667-42.667-42.667h-768c-23.552 0-42.667 19.115-42.667 42.667s19.115 42.667 42.667 42.667zM128 810.667h768c23.552 0 42.667-19.115 42.667-42.667s-19.115-42.667-42.667-42.667h-768c-23.552 0-42.667 19.115-42.667 42.667s19.115 42.667 42.667 42.667z"></path>
            </svg>
          </div>
          <div data-thq="thq-mobile-menu" className="home-thq-mobile-menu-elm">
            <div className="home-thq-nav-elm">
              <div className="home-thq-top-elm">
                <span className="home-text13">R.A.C.E. Consulting</span>
                <div
                  data-thq="thq-close-menu"
                  className="home-thq-close-menu-elm"
                >
                  <svg viewBox="0 0 1024 1024" className="home-icon21">
                    <path d="M810 274l-238 238 238 238-60 60-238-238-238 238-60-60 238-238-238-238 60-60 238 238 238-238z"></path>
                  </svg>
                </div>
              </div>
              <nav className="home-thq-links-elm2">
                <Link to="/" className="home-navlink16">
                  Home
                </Link>
                <Link to="/services" className="home-navlink17">
                  Services
                </Link>
                <Link to="/about-us" className="home-navlink18">
                  About Us
                </Link>
                <Link to="/contact-us" className="home-navlink19">
                  Contact Us
                </Link>
              </nav>
              <div>
                <a
                  href="https://www.facebook.com/share/1CHjJ68yyA/?mibextid=wwXIfr"
                  target="_blank"
                  rel="noreferrer noopener"
                >
                  <svg
                    viewBox="0 0 602.2582857142856 1024"
                    className="home-icon23"
                  >
                    <path d="M548 6.857v150.857h-89.714c-70.286 0-83.429 33.714-83.429 82.286v108h167.429l-22.286 169.143h-145.143v433.714h-174.857v-433.714h-145.714v-169.143h145.714v-124.571c0-144.571 88.571-223.429 217.714-223.429 61.714 0 114.857 4.571 130.286 6.857z"></path>
                  </svg>
                </a>
                <a
                  href="https://www.instagram.com/race.consulting?igsh=ZjU1bzB3OG01cnBv&amp;utm_source=qr"
                  target="_blank"
                  rel="noreferrer noopener"
                >
                  <svg
                    viewBox="0 0 877.7142857142857 1024"
                    className="home-icon25"
                  >
                    <path d="M585.143 512c0-80.571-65.714-146.286-146.286-146.286s-146.286 65.714-146.286 146.286 65.714 146.286 146.286 146.286 146.286-65.714 146.286-146.286zM664 512c0 124.571-100.571 225.143-225.143 225.143s-225.143-100.571-225.143-225.143 100.571-225.143 225.143-225.143 225.143 100.571 225.143 225.143zM725.714 277.714c0 29.143-23.429 52.571-52.571 52.571s-52.571-23.429-52.571-52.571 23.429-52.571 52.571-52.571 52.571 23.429 52.571 52.571zM438.857 152c-64 0-201.143-5.143-258.857 17.714-20 8-34.857 17.714-50.286 33.143s-25.143 30.286-33.143 50.286c-22.857 57.714-17.714 194.857-17.714 258.857s-5.143 201.143 17.714 258.857c8 20 17.714 34.857 33.143 50.286s30.286 25.143 50.286 33.143c57.714 22.857 194.857 17.714 258.857 17.714s201.143 5.143 258.857-17.714c20-8 34.857-17.714 50.286-33.143s25.143-30.286 33.143-50.286c22.857-57.714 17.714-194.857 17.714-258.857s5.143-201.143-17.714-258.857c-8-20-17.714-34.857-33.143-50.286s-30.286-25.143-50.286-33.143c-57.714-22.857-194.857-17.714-258.857-17.714zM877.714 512c0 60.571 0.571 120.571-2.857 181.143-3.429 70.286-19.429 132.571-70.857 184s-113.714 67.429-184 70.857c-60.571 3.429-120.571 2.857-181.143 2.857s-120.571 0.571-181.143-2.857c-70.286-3.429-132.571-19.429-184-70.857s-67.429-113.714-70.857-184c-3.429-60.571-2.857-120.571-2.857-181.143s-0.571-120.571 2.857-181.143c3.429-70.286 19.429-132.571 70.857-184s113.714-67.429 184-70.857c60.571-3.429 120.571-2.857 181.143-2.857s120.571-0.571 181.143 2.857c70.286 3.429 132.571 19.429 184 70.857s67.429 113.714 70.857 184c3.429 60.571 2.857 120.571 2.857 181.143z"></path>
                  </svg>
                </a>
                <a
                  href="https://www.linkedin.com/in/melissa-decker-7a6181303?utm_source=share&amp;utm_campaign=share_via&amp;utm_content=profile&amp;utm_medium=ios_app"
                  target="_blank"
                  rel="noreferrer noopener"
                >
                  <svg
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    className="home-icon27"
                  >
                    <path
                      d="M9.429 8.969h3.714v1.85c.535-1.064 1.907-2.02 3.968-2.02c3.951 0 4.889 2.118 4.889 6.004V22h-4v-6.312c0-2.213-.535-3.461-1.897-3.461c-1.889 0-2.674 1.345-2.674 3.46V22h-4zM2.57 21.83h4V8.799h-4zM7.143 4.55a2.53 2.53 0 0 1-.753 1.802a2.57 2.57 0 0 1-1.82.748a2.6 2.6 0 0 1-1.818-.747A2.55 2.55 0 0 1 2 4.55c0-.677.27-1.325.753-1.803A2.58 2.58 0 0 1 4.571 2c.682 0 1.336.269 1.819.747s.753 1.126.753 1.803"
                      fill="currentColor"
                      clipRule="evenodd"
                      fillRule="evenodd"
                    ></path>
                  </svg>
                </a>
                <a
                  href="https://www.youtube.com/@MelissaDecker-n6k"
                  target="_blank"
                  rel="noreferrer noopener"
                >
                  <svg
                    height="21"
                    width="21"
                    viewBox="4 -2 42 42"
                    className="home-icon31"
                  >
                    <g fill="none" stroke="currentColor" strokeLinejoin="round">
                      <path
                        strokeWidth="4"
                        d="M11.064 10.414Q19.378 10 23.998 10t12.939.415a6 6 0 0 1 5.68 5.492q.381 4.55.381 8.017q0 3.508-.39 8.128a6 6 0 0 1-5.587 5.483Q29.91 38 23.998 38q-5.91 0-13.018-.465a6 6 0 0 1-5.587-5.48q-.395-4.655-.395-8.131q0-3.435.385-8.02a6 6 0 0 1 5.68-5.49Z"
                      ></path>
                      <path
                        strokeWidth="3.429"
                        d="M21 19.61v8.796a.857.857 0 0 0 1.33.715l6.597-4.36a.857.857 0 0 0 .006-1.427l-6.598-4.436a.857.857 0 0 0-1.335.711Z"
                      ></path>
                    </g>
                  </svg>
                </a>
              </div>
            </div>
          </div>
        </header>
      </div>
      <div className="home-thq-section1-elm">
        <div className="home-container15">
          <div className="home-thq-cards-container-elm">
            <div className="home-thq-card1-elm">
              <img
                alt="image"
                src="https://raceconsulting24.com/all_in_packages-200h.png"
                className="home-image13"
              />
              <h6 className="home-text14 TextXL">All-In Packages</h6>
              <span className="home-text15">
                <span>
                  8th-12th grade packages with personalized high school
                  advising, college admissions planning and career exploration.
                </span>
                <br></br>
              </span>
              <Link to="/services" className="home-navlink20 TextXS button">
                Learn More
              </Link>
            </div>
            <div className="home-thq-card2-elm">
              <img
                alt="image"
                src="https://raceconsulting24.com/college_admissions-200h.png"
                className="home-image14"
              />
              <h6 className="home-text18 TextXL">College Admissions</h6>
              <span className="home-text19">
                Assistance in college applications, college list, essays, resume
                and activities list.
              </span>
              <Link to="/services" className="home-navlink21 TextXS button">
                Learn More
              </Link>
            </div>
            <div className="home-thq-card3-elm">
              <img
                alt="image"
                src="https://raceconsulting24.com/career_exploration-200h.png"
                className="home-image15"
              />
              <h6 className="home-text20 TextXL">Career Exploration</h6>
              <span className="home-text21">
                Dive deeper into exploring career and college majors.
              </span>
              <Link to="/services" className="home-navlink22 TextXS button">
                Learn More
              </Link>
            </div>
            <div className="home-thq-card4-elm">
              <img
                alt="image"
                src="https://raceconsulting24.com/scholarship_assistance-200h.png"
                className="home-image16"
              />
              <h6 className="home-text22 TextXL">Scholarship Assistance</h6>
              <span className="home-text23">
                High School and Undergraduate Scholarships researched and
                organized for easy applying with scholarship essay assistance.
              </span>
              <Link to="/services" className="home-navlink23 TextXS button">
                Learn More
              </Link>
            </div>
          </div>
          <div className="home-thq-work-with-us-elm">
            <div className="home-container16">
              <span className="home-text31 TextLG">
                Many high school students feel overwhelmed about where to start
                with college admissions or how to choose a career path. At
                R.A.C.E. Consulting, we provide clear, intentional guidance to
                help your student navigate every step so the stress doesn’t fall
                on you.
              </span>
            </div>
            <div className="home-container17">
              <div className="home-container18"></div>
              <div className="home-container19">
                <h4 className="home-text32 Healine">
                  <span className="home-text33">Years of Experience</span>
                  <br></br>
                </h4>
                <span className="home-text35">
                  <span>
                    With a foundation built on years of experience and proven
                    consulting strategies, R.A.C.E. Consulting guides students
                    every step of the way - from their first day of 9th grade to
                    graduation and college acceptance.
                  </span>
                  <br></br>
                  <br></br>
                  <span>
                    We provide consistent, personalized support to ensure each
                    student feels confident, prepared, and empowered to pursue
                    their unique path forward.
                  </span>
                  <br></br>
                </span>
              </div>
            </div>
          </div>
        </div>
        <img
          alt="image"
          src="https://raceconsulting24.com/white-vector.svg"
          className="home-image18"
        />
      </div>
      <div className="home-thq-section2-elm">
        <div className="home-thq-growing-company-section-elm">
          <div className="home-container20">
            <h3 className="home-text41">
              Ready to learn more about our consulting packages and services?
            </h3>
            <span className="home-text42">
              Your journey with R.A.C.E. Consulting begins with a complimentary,
              30-minute consultation designed to understand your student’s
              unique needs, goals, and challenges. During this session, we’ll
              explore where they are in their high school journey, discuss
              potential academic or career paths, and determine how our
              personalized support can make a lasting impact.
            </span>
            <Link to="/contact-us" className="home-navlink25 button">
              SCHEDULE A CONSULTATION
            </Link>
          </div>
          <img
            alt="image"
            src="https://raceconsulting24.com/work_station-1400w.jpeg"
            className="home-image19"
          />
        </div>
        <div className="home-container21">
          <img
            alt="image"
            src="https://raceconsulting24.com/gray-vector.svg"
            className="home-image20"
          />
          <h3 className="home-text43 Healine">Real Journeys, Real Results</h3>
          <div
            data-thq="slider"
            data-loop="true"
            data-autoplay="true"
            data-navigation="false"
            data-pagination="true"
            data-autoplay-delay="6000"
            data-pause-autoplay-on-mouse-enter="true"
            data-disable-autoplay-on-interaction="true"
            className="home-thq-slider-elm swiper"
          >
            <div data-thq="slider-wrapper" className="swiper-wrapper">
              <div
                data-thq="slider-slide"
                className="home-thq-slider-slide-elm10 swiper-slide"
              >
                <img
                  alt="image"
                  src="https://raceconsulting24.com/pettryFamily.jpeg"
                  className="home-image32"
                />
                <span className="home-text80">
                  <span>
                    “Melissa was a life saver for the scholarship process for my daughter. As a family of two full-time working parents and a student who also works, we just didn't have the margin to do the deep research to find the best scholarships for our student. Melissa did all the leg work for us, which saved our family so much time and allowed our student to focus on giving it her all to the scholarships that were most applicable. We are all so grateful! Can't recommend her enough!”
                  </span>
                  <br></br>
                  <span>-The Pettry Family </span>
                  <br></br>
                  <span>
                    <span
                      dangerouslySetInnerHTML={{
                        __html: ' ',
                      }}
                    />
                  </span>
                </span>
              </div>
              <div
                data-thq="slider-slide"
                className="home-thq-slider-slide-elm7 swiper-slide"
              >
                <img
                  alt="image"
                  src="https://raceconsulting24.com/jadenN.jpeg"
                  className="home-image28"
                />
                <span className="home-text68">
                  <span>
                    “Mrs.Decker was extremely helpful for my college application process. She helped me revise my essay into a polished final product and that was still my words and ideas. If you are unsure where to start or just need someone who can support you while applying to college, I would wholeheartedly recommend using RACE!”
                  </span>
                  <br></br>
                  <span>-Jaden N.</span>
                  <br></br>
                  <span>
                    <span
                      dangerouslySetInnerHTML={{
                        __html: ' ',
                      }}
                    />
                  </span>
                </span>
              </div>
              <div
                data-thq="slider-slide"
                className="home-thq-slider-slide-elm9 swiper-slide"
              >
                <img
                  alt="image"
                  src="https://raceconsulting24.com/fieldsFamily.jpeg"
                  className="home-image30"
                />
                <span className="home-text76">
                  <span>
                    “I worked with Melissa on my son’s scholarship search. She was exceptional from start to finish. She curated the right scholarship list, set clear timelines and communicated directly with my son while keeping me in the loop. She made a complex process feel clear and manageable. We were very grateful.”
                  </span>
                  <br></br>
                  <span>-The Fields Family</span>
                  <br></br>
                  <span>
                    <span
                      dangerouslySetInnerHTML={{
                        __html: ' ',
                      }}
                    />
                  </span>
                </span>
              </div>
              <div
                data-thq="slider-slide"
                className="home-thq-slider-slide-elm1 swiper-slide"
              >
                <img
                  alt="image"
                  src="https://raceconsulting24.com/rileys-900w.jpg"
                  className="home-image21"
                />
                <span className="home-text44">
                  <span>
                    “I really appreciate everything you did for me my Senior
                    year. It felt really hard transitioning from junior year to
                    senior year because it felt like I had to know everything
                    about my future and how to apply to colleges all of a
                    sudden. You really helped me take it step by step slowly
                    &amp; easily so that my college application process went
                    smoothly!”
                    <span
                      dangerouslySetInnerHTML={{
                        __html: ' ',
                      }}
                    />
                  </span>
                  <br></br>
                  <span> -Riley S.</span>
                </span>
              </div>
              <div
                data-thq="slider-slide"
                className="home-thq-slider-slide-elm2 swiper-slide"
              >
                <img
                  alt="image"
                  src="https://raceconsulting24.com/baileyfamily-900w.jpeg"
                  className="home-image22"
                />
                <span className="home-text48">
                  <span>
                    “If anyone is feeling overwhelmed like I was about
                    everything going into senior year with your kiddos and
                    college prep, you have to reach out and work with Melissa.
                    She was a huge help with all that goes into preparing your
                    child for college. She worked with my daughter one on one
                    throughout the year and Ansley and I seriously would have
                    been lost if it wasn&apos;t for her! I truly had no idea how
                    much went into college applications. All the testing,
                    visits, resumes, essays for students and even more that was
                    stressing me out every single second of the day. She truly
                    made the process so easy and so fun, as well. At the end of
                    the day, you just want to make sure your kids have all the
                    tools necessary to take that huge leap into adulthood and
                    Melissa provided that for us. I cannot thank her enough for
                    pouring her heart and soul into Ansley the way that she did.
                    If I could give her a 100-star rating, I would.”
                    <span
                      dangerouslySetInnerHTML={{
                        __html: ' ',
                      }}
                    />
                  </span>
                  <br></br>
                  <span> -The Bailey Family</span>
                </span>
              </div>
              <div
                data-thq="slider-slide"
                className="home-thq-slider-slide-elm3 swiper-slide"
              >
                <img
                  alt="image"
                  src="https://raceconsulting24.com/simpsonfamily-900w.jpeg"
                  className="home-image23"
                />
                <span className="home-text52">
                  <span>
                    “I highly recommend RACE Consulting and Melissa to help your
                    senior navigate the college search and application process!
                    Melissa’s expertise was a valuable resource to my daughter
                    as she narrowed down her college choices and worked through
                    the applications for each school. She met one-on-one with my
                    daughter and provided invaluable step-by-step direction and
                    encouragement. Melissa truly cares about helping find the
                    perfect college fit. She was flexible with our busy
                    schedule, always finding time to give guidance or an
                    encouraging word. She truly is one of a kind! The entire
                    process was seamless and stress free for our family. I
                    highly recommend using Melissa and Race Consulting!”
                    <span
                      dangerouslySetInnerHTML={{
                        __html: ' ',
                      }}
                    />
                  </span>
                  <br></br>
                  <span> -The Simpson Family</span>
                </span>
              </div>
              <div
                data-thq="slider-slide"
                className="home-thq-slider-slide-elm4 swiper-slide"
              >
                <img
                  alt="image"
                  src="https://raceconsulting24.com/hammondsfamily-900w.jpeg"
                  className="home-image24"
                />
                <span className="home-text56">
                  <span>
                    “Melissa was a priceless resource to our family as our son
                    was navigating the college search process! She met with him
                    one-on-one, provided the steps and resources he needed,
                    followed up, and was always available for his/our questions.
                    Melissa TRULY cares about the students she works with, and
                    provides much more specialized guidance than most high
                    school guidance counselors. She’s very passionate about her
                    work in helping students and parents navigate the college
                    application process! I highly recommend RACE Consulting and
                    Melissa!”
                    <span
                      dangerouslySetInnerHTML={{
                        __html: ' ',
                      }}
                    />
                  </span>
                  <br></br>
                  <span> -The Hammonds Family</span>
                </span>
              </div>
              <div
                data-thq="slider-slide"
                className="home-thq-slider-slide-elm5 swiper-slide"
              >
                <img
                  alt="image"
                  src="https://raceconsulting24.com/monticupfamily-900w.jpeg"
                  className="home-image25"
                />
                <span className="home-text60">
                  <span>
                    “We had a great experience with Melissa, both from a parent
                    point of view as well as the student. This was my first
                    child going through the college application process and
                    Melissa helped us navigate, lessening the anxiety throughout
                    the process. She was responsive and my daughter found her to
                    be understanding and easy to talk to which helped ease her
                    fears. Melissa was a great partner to have!”
                    <span
                      dangerouslySetInnerHTML={{
                        __html: ' ',
                      }}
                    />
                  </span>
                  <br></br>
                  <span>
                    {' '}
                    -The Monticup Family
                    <span
                      dangerouslySetInnerHTML={{
                        __html: ' ',
                      }}
                    />
                  </span>
                </span>
              </div>
              <div
                data-thq="slider-slide"
                className="home-thq-slider-slide-elm6 swiper-slide"
              >
                <img
                  alt="image"
                  src="https://raceconsulting24.com/deckerfamily-900w.jpeg"
                  className="home-image26"
                />
                <span className="home-text64">
                  <span>
                    “We highly recommend Melissa and RACE Consulting. Our son
                    was determined to avoid college because he thought he
                    couldn’t find something he would like. After a few guided
                    conversations and understanding the possible options and
                    potential career paths, he found a college that was perfect
                    for him. Without her expertise, guidance, and encouragement
                    he would not be going to school this fall. Thank you for
                    helping him uncover his new path!”
                  </span>
                  <br></br>
                  <span>-The Decker Family</span>
                  <br></br>
                  <span>
                    <span
                      dangerouslySetInnerHTML={{
                        __html: ' ',
                      }}
                    />
                  </span>
                </span>
              </div>
            </div>
            <div
              data-thq="slider-pagination"
              className="home-thq-slider-pagination-elm swiper-pagination swiper-pagination-bullets swiper-pagination-horizontal"
            >
              <div
                data-thq="slider-pagination-bullet"
                className="swiper-pagination-bullet swiper-pagination-bullet-active"
              ></div>
              <div
                data-thq="slider-pagination-bullet"
                className="swiper-pagination-bullet"
              ></div>
              <div
                data-thq="slider-pagination-bullet"
                className="swiper-pagination-bullet"
              ></div>
              <div
                data-thq="slider-pagination-bullet"
                className="swiper-pagination-bullet swiper-pagination-bullet-active"
              ></div>
              <div
                data-thq="slider-pagination-bullet"
                className="swiper-pagination-bullet swiper-pagination-bullet-active"
              ></div>
            </div>
            <div
              data-thq="slider-button-prev"
              className="home-thq-slider-button-prev-elm swiper-button-prev"
            ></div>
            <div
              data-thq="slider-button-next"
              className="home-thq-slider-button-next-elm swiper-button-next"
            ></div>
          </div>
          <img
            alt="image"
            src="https://raceconsulting24.com/white-vector.svg"
            className="home-image27"
          />
        </div>
        <div className="home-thq-youtube-section-elm">
          <YouTube
            videoId="9K475FtVAh4"
            className="home-video"
            opts={{
              width: '100%',
              height: '360',
              playerVars: {
                autoplay: 1,
                mute: 1,
                controls: 1,
                rel: 0,
                modestbranding: 1,
                playsinline: 1,
              },
            }}
          />
          <div className="home-container22">
            <h3 className="home-text70">“What You Need To Know” Short Clips</h3>
            <span className="home-text71">
              Do you find yourself asking your student questions they can’t answer? Do you feel overwhelmed by ALL the topics associated with College Admissions? R.A.C.E. Consulting advises all families along the way with resources, 1-on-1 calls, and answers to all your questions. Check out some of the questions answered <a href="https://www.youtube.com/@MelissaDecker-n6k/shorts" target="_blank" rel="noopener noreferrer" style={{ color: '#0074d9', textDecoration: 'underline', fontWeight: 'bold', textTransform: 'uppercase' }}>HERE</a> in our short videos!
            </span>
          </div>
        </div>
      </div>
      <Footer></Footer>
    </div>
  )
}

export default Home
